import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-header-bar-left-actions>` is a component that renders one or more `<labs-header-bar-action>`
 */
@Component({
  selector: 'labs-header-bar-left-actions',
  template: '<ng-content select="labs-header-bar-action"></ng-content>',
  styleUrls: ['./header-bar-left-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderBarLeftActionsComponent {}
